/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const CheckIcon: React.FC = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 7.91998L9.84 16.08L6 12.24"
      stroke="#0FCCCE"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
